import { RetailUnitSchema } from '@lotta/shared/types-lottery-schemas';
import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';
import { LotteryResponseSchema } from './common';

export type GetLotteriesParams = Static<typeof GetLotteriesParamsSchema>;
export const GetLotteriesParamsSchema = Type.Object(
  {
    retailUnit: RetailUnitSchema.properties.id,
  },
  { additionalProperties: false, $id: 'GetLotteriesParamsSchema' }
);

export type GetLotteriesResponse = Static<typeof GetLotteriesResponseSchema>;
export const GetLotteriesResponseSchema = Type.Object(
  {
    lotteries: Type.Array(LotteryResponseSchema),
  },
  { additionalProperties: false, $id: 'GetLotteriesResponseSchema' }
);
